import dayjs from "dayjs";
import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDate from "../../../modules/SimpleDate";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleTextArea from "../../../modules/simpleTextArea";
import Api from "../../../Services/Api";
import { Status } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

class MasterUserFilter extends Component {
  statusOptions = [
    {
      label: Status.ACTIVE,
      value: Status.ACTIVE,
    },
    {
      label: Status.INACTIVE,
      value: Status.INACTIVE,
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      provinceOptions: [],
      religionOptions: [],
      genderOptions: [],
    };
  }

  async componentDidMount() {
    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllProvince(),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "RELIGION_TYPE",
          status: Status.ACTIVE,
        },
      }),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "GENDER_TYPE",
        },
      }),
    ]);

    if (responses[0].ok && !R.isEmpty(responses[0].data.data)) {
      this.setOptionsData("provinceOptions", responses[0].data.data);
    }

    if (responses[1].ok && !R.isEmpty(responses[1].data.data)) {
      this.setOptionsData("religionOptions", responses[1].data.data);
    }

    if (responses[2].ok && !R.isEmpty(responses[2].data.data)) {
      this.setOptionsData("genderOptions", responses[2].data.data);
    }
  }

  setOptionsData = (key, data) => {
    if (R.equals(key, "provinceOptions")) {
      this.setState((prevValue) => ({
        ...prevValue,
        [key]: data.map((option) => mapToObjectDDL(option.provinceName, option.id)),
      }));
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        [key]: data.map((option) => mapToObjectDDL(option.value, option.key)),
      }));
    }
  };

  getFilterDataValue = (fieldName, fallbackValue = "") => {
    return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  };

  handleChangeProvince = async (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
        kabkot: null,
        kecamatan: null,
      },
    }));
    if (!R.isNil(value)) {
      try {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(value.value);
        if (response.ok) {
          this.props.onSetState((prevValue) => ({
            ...prevValue,
            kotaOptions: response.data.data.map((option) =>
              mapToObjectDDL(option.kabKotName, option.kabKotId)
            ),
          }));
        }
      } catch (error) {
        // TODO
      }
    }
  };

  handleChangeKota = async (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
        kecamatan: null,
      },
    }));
    if (!R.isNil(value)) {
      try {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(value.value);
        if (response.ok) {
          this.props.onSetState((prevValue) => ({
            ...prevValue,
            kecamatanOptions: response.data.data.map((option) =>
              mapToObjectDDL(option.kecamatanName, option.id)
            ),
          }));
        }
      } catch (error) {
        // TODO
      }
    }
  };

  handleChangeKecamatan = async (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
    if (!R.isNil(value)) {
      try {
        const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(value.value);
        if (response.ok) {
          this.props.onSetState((prevValue) => ({
            ...prevValue,
            kelurahanOptions: response.data.data.map((option) => ({
              ...mapToObjectDDL(option.zipcode, option.zipcode),
              kelurahanId: option.id,
            })),
          }));
        }
      } catch (error) {
        // TODO
      }
    }
  };

  handleResetFilter = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: null,
    }));
  };

  handleFilterValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleTextChange = ({ target }) => {
    this.handleFilterValueChange(target.name, target.value);
  };

  handleDDLChange = (value, { name }) => {
    this.handleFilterValueChange(name, value);
  };

  handleResignDateChange = (value) => {
    if (
      !R.isNil(this.getFilterDataValue("tanggalMasuk")) &&
      dayjs(value).isBefore(this.getFilterDataValue("tanggalMasuk"))
    ) {
      this.handleFilterValueChange("tanggalResign", value);
      this.handleFilterValueChange("tanggalMasuk", value);
    } else {
      this.handleFilterValueChange("tanggalResign", value);
    }
  };

  render() {
    return (
      <SimpleModal
        title="Filter"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <div className="padding-15px grid grid-2x grid-mobile-none gap-15px">
              {this.renderForm()}
              {this.renderForm1()}
            </div>
            <FlexView hAlignContent="right" style={{ gap: "10px" }}>
              <SimpleButton type="button" secondary onClick={this.handleResetFilter}>
                Hapus
              </SimpleButton>
              <SimpleButton type="button" onClick={this.props.onSubmit}>
                Terapkan
              </SimpleButton>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }

  renderForm() {
    return (
      <div>
        <SimpleInput
          id="input_text_nama_karyawan"
          label="Nama Karyawan"
          name="name"
          value={this.getFilterDataValue("name")}
          onChange={this.handleTextChange}
        />
        <SimpleInput
          id="input_text_nik_karyawan"
          label="NIK Karyawan"
          name="nik"
          value={this.getFilterDataValue("nik")}
          onChange={this.handleTextChange}
        />
        <SimpleInput
          id="input_text_no_ktp"
          label="No. KTP"
          name="ktpNumber"
          box="onlyNumber"
          maxLength={16}
          value={this.getFilterDataValue("ktpNumber")}
          onChange={this.handleTextChange}
        />
        <SimpleInput
          id="input_text_no_hp"
          label="No. HP"
          name="hpNumber"
          box="onlyNumber"
          maxLength={14}
          value={this.getFilterDataValue("hpNumber")}
          onChange={this.handleTextChange}
        />
        <SimpleInput
          id="input_text_email"
          label="Email"
          name="email"
          type="email"
          value={this.getFilterDataValue("email")}
          onChange={this.handleTextChange}
        />
        <SimpleDDL
          id="select_options_agama"
          box="search"
          label="Agama"
          name="religion"
          isClearable
          options={this.state.religionOptions}
          value={this.getFilterDataValue("religion")}
          onChange={this.handleDDLChange}
        />
        <SimpleDate
          id="select_date_tanggal_lahir"
          name="birthdate"
          label="Tanggal Lahir"
          nextdate
          date={this.getFilterDataValue("birthdate", null)}
          onChange={(value) => this.handleFilterValueChange("birthdate", value)}
        />
        <SimpleDDL
          id="select_options_jenis_kelamin"
          box="search"
          label="Jenis Kelamin"
          name="gender"
          isClearable
          options={this.state.genderOptions}
          value={this.getFilterDataValue("gender", null)}
          onChange={this.handleDDLChange}
        />
        <SimpleInput
          id="input_text_npwp"
          label="No. NPWP"
          name="npwpNumber"
          box="onlyNumber"
          value={this.getFilterDataValue("npwpNumber")}
          onChange={this.handleTextChange}
        />
        <SimpleInput
          id="input_text_status_pajak"
          label="Status Pajak"
          name="taxstatus"
          value={this.getFilterDataValue("taxstatus")}
          onChange={this.handleTextChange}
        />
        <SimpleInput
          id="input_text_no_bpjs_kesehatan"
          label="No. BPJS Kesehatan"
          name="bpjsnumber"
          box="onlyNumber"
          value={this.getFilterDataValue("bpjsnumber")}
          onChange={this.handleTextChange}
        />
      </div>
    );
  }

  renderForm1() {
    return (
      <div>
        <SimpleInput
          id="input_text_no_bpjs_ketenagakerjaan"
          label="No. BPJS Ketenagakerjaan"
          name="bpjstkNumber"
          box="onlyNumber"
          value={this.getFilterDataValue("bpjstkNumber")}
          onChange={this.handleTextChange}
        />
        <SimpleTextArea
          id="input_text_alamat"
          typeInputCase="normal"
          label="Alamat"
          name="address"
          value={this.getFilterDataValue("address")}
          onChange={this.handleTextChange}
        />
        <SimpleDDL
          id="select_options_provinsi"
          box="search"
          label="Provinsi"
          name="province"
          isClearable
          options={this.state.provinceOptions}
          value={this.getFilterDataValue("province", null)}
          onChange={(value, { name }) => this.handleChangeProvince(name, value)}
        />
        <SimpleDDL
          id="select_options_kota"
          box="search"
          label="Kota"
          name="kabkot"
          isClearable
          options={this.props.state.kotaOptions}
          readOnly={R.isNil(this.getFilterDataValue("province", null))}
          value={this.getFilterDataValue("kabkot", null)}
          onChange={(value, { name }) => this.handleChangeKota(name, value)}
        />
        <SimpleDDL
          id="select_options_kecamatan"
          box="search"
          label="Kecamatan"
          name="kecamatan"
          isClearable
          options={this.props.state.kecamatanOptions}
          readOnly={R.isNil(this.getFilterDataValue("kabkot", null))}
          value={this.getFilterDataValue("kecamatan", null)}
          onChange={(value, { name }) => this.handleChangeKecamatan(name, value)}
        />
        <SimpleInput
          id="input_text_kode_pos"
          label="Kode Pos"
          name="zipcode"
          value={this.getFilterDataValue("zipcode")}
          onChange={this.handleTextChange}
        />
        <div id="tanggal_masuk">
          <SimpleDate
            id="select_date_tanggal_masuk"
            label="Tanggal Masuk"
            name="tanggalMasuk"
            nextdate
            maxDate={this.getFilterDataValue("tanggalResign") || new Date()}
            date={this.getFilterDataValue("tanggalMasuk")}
            onChange={(value) => this.handleFilterValueChange("tanggalMasuk", value)}
          />
        </div>
        <div id="tanggal_keluar">
          <SimpleDate
            id="select_options_tanggal_keluar"
            box="search"
            label="Tanggal Keluar"
            name="tanggalResign"
            nextdate
            date={this.getFilterDataValue("tanggalResign")}
            onChange={(value) => this.handleResignDateChange(value)}
          />
        </div>
        <SimpleInput
          id="input_text_username"
          label="Username"
          name="username"
          value={this.getFilterDataValue("username")}
          onChange={this.handleTextChange}
        />
        <SimpleDDL
          id="select_options_status"
          box="search"
          isClearable
          label="Status"
          name="status"
          options={this.statusOptions}
          value={this.getFilterDataValue("status")}
          onChange={this.handleDDLChange}
        />
      </div>
    );
  }
}

export default MasterUserFilter;
